import request from ".";

export const presidentMsgApi = {
  getPresidentMsg: () => request.post(`PresidentMsg/getPresidentMsg`),
};
